<template>
  <div>
    <v-text-field
      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
      :rules="[rules.passwordRequired, rules.passwordLength]"
      :type="showPassword ? 'text' : 'password'"
      label="Nyt password"
      v-model="password"
      @keydown.space="event => event.preventDefault()"
      @click:append="showPassword = !showPassword"
      @blur="updatePassword"
      outlined
      dense
      color="primary"
      background-color="white"
    />
    <v-text-field
      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
      :rules="[rules.passwordRequired, rules.passwordMatch]"
      :type="showPassword ? 'text' : 'password'"
      label="Gentag nyt password"
      v-model="passwordConfirmation"
      @keydown.space="event => event.preventDefault()"
      @click:append="showPassword = !showPassword"
      outlined
      dense
      color="primary"
      background-color="white"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPassword: false,
      rules: {
        passwordRequired: v => !!v || "Password skal udfyldes",
        passwordLength: v => (v && v.length >= 8) || "Min. 8 karakterer",
        passwordMatch: () =>
          new String(this.password).valueOf() ===
            new String(this.passwordConfirmation).valueOf() ||
          "Passwords er ikke ens"
      },
      password: "",
      passwordConfirmation: ""
    };
  },
  methods: {
    updatePassword() {
      this.$emit("passwordUpdated", this.password);
    }
  }
};
</script>
